import { PermissionSetGroupingKey } from '../PermissionSetTypes'
import { PermissionType } from '../PermissionType'

export enum EdiBrokerConfigurationPermissionSet {
  View = 'edi_broker_configuration_view',
  Write = 'edi_broker_configuration_write',
}

export const EdiBrokerConfigurationPermissions = {
  [EdiBrokerConfigurationPermissionSet.View]: [PermissionType.GET_ANY_EDI_BROKER_CONFIGURATION],
  [EdiBrokerConfigurationPermissionSet.Write]: [PermissionType.WRITE_ANY_EDI_BROKER_CONFIGURATION],
}

export const ediBrokerConfigurationPermissionSetGrouping = {
  key: PermissionSetGroupingKey.EdiBrokerConfiguration,
  active: EdiBrokerConfigurationPermissions,
  unAssignablePermissionSets: [],
}
